import { forwardRef, type ForwardedRef } from 'react';
// @mui
import { Box, type SxProps, type Theme } from '@mui/material';

// ----------------------------------------------------------------------

interface SvgColorProps {
	src?: string;
	sx?: SxProps<Theme>;
}

const SvgColor = forwardRef<HTMLSpanElement, SvgColorProps>(
	({ src, sx, ...other }, ref: ForwardedRef<HTMLSpanElement>) => (
		<Box
			component="span"
			className="svg-color"
			ref={ref}
			sx={{
				width: 24,
				height: 24,
				display: 'inline-block',
				bgcolor: 'currentColor',
				mask: `url(${src}) no-repeat center / contain`,
				WebkitMask: `url(${src}) no-repeat center / contain`,
				...sx,
			}}
			{...other}
		/>
	),
);

export default SvgColor;
